export const DEFAULT_KYC_DOCUMENT_SECTIONS = [
  {
    id: 'id-proof',
    label: 'ID Proof',
    labelMessageId: 'kycIdProof',
  },
  {
    id: 'income-proof',
    label: 'Income Proof',
    labelMessageId: 'kycIncomeProof',
  },
  {
    id: 'address-proof',
    label: 'Address Proof',
    labelMessageId: 'kycAddressProof',
  },
];

export const DEFAULT_ID_TYPE_METADATA = [
  {
    id: 'state-id',
    label: 'State ID',
    sides: ['front', 'back'],
  },
  {
    id: 'passport',
    label: 'Passport',
    sides: ['front'],
  },
];

export const getMockKycDocumentSections = async () => DEFAULT_KYC_DOCUMENT_SECTIONS;

export const getMockIdTypeMetadata = async () => DEFAULT_ID_TYPE_METADATA;
